module.exports = __webpack_public_path__ + "static/media/codename-search.2b6558bb.svg";